// Message types:
export const MESSAGE_TYPE_NONE = 'none';
export const MESSAGE_TYPE_SUCCESS = 'success';
export const MESSAGE_TYPE_ERROR = 'error';
export const MESSAGE_TYPE_INFO = 'info';
export const MESSAGE_TYPE_WARNING = 'warning';

